import {useMutation} from "@tanstack/react-query";

import {updateMaterialMutationOptions} from "./update-material.mutation-options";

export function useUpdateMaterial(id: string) {
  return useMutation(updateMaterialMutationOptions(id));
}
